import { useEffect, useRef } from "react"

/**
 * @param {{
 *   enabled?: boolean,
 *   hasMore: boolean,
 *   isLoading: boolean,
 *   onLoadMore: () => void,
 *   rootMargin?: string,
 * }} config
 */
export default function useInfiniteScrollTrigger({
    enabled = true,
    hasMore,
    isLoading,
    onLoadMore,
    rootMargin = "320px 0px 320px 0px",
}) {
    const sentinelRef = useRef(/** @type {HTMLDivElement | null} */ (null))

    useEffect(() => {
        if (!enabled || !sentinelRef.current) {
            return
        }

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0]
            if (!entry?.isIntersecting) {
                return
            }
            if (!hasMore || isLoading) {
                return
            }
            onLoadMore()
        }, { root: null, rootMargin, threshold: 0 })

        observer.observe(sentinelRef.current)
        return () => observer.disconnect()
    }, [enabled, hasMore, isLoading, onLoadMore, rootMargin])

    return sentinelRef
}

